import { AxiosService } from '@/shared/utils'
import { AxiosRequestConfig } from 'axios'
import {
  StatisticFilterType,
  OrganizationPartner,
  OrganizationStatus,
  OrganizationSubscription,
} from '@/shared/types'

class StatisticApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public getOrganizationDynamicReportCreation(
    dateFrom: Date,
    dateTo: Date,
    maxAmount: number,
    minAmount: number,
    countOnPage: number,
    offset: number,
    partner: OrganizationPartner,
    status: OrganizationStatus,
    tariffTitle: string,
    organizationName: string,
    showArchive: boolean,
    subscriptionType: OrganizationSubscription
  ) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/statistic/report-dynamics-organization',
      params: {
        date_from: dateFrom,
        date_to: dateTo,
        max_amount: maxAmount,
        min_amount: minAmount,
        count: countOnPage,
        offset,
        partner,
        status,
        tariff_title: tariffTitle,
        organization_name: organizationName,
        show_inactive: Number(showArchive),
        subscription_type: subscriptionType,
      },
    })
  }

  public getUserDynamicReportCreation(
    organizationId: string,
    dateFrom: Date,
    dateTo: Date,
    maxAmount: number,
    minAmount: number,
    countOnPage: number,
    offset: number,
    userName: string
  ) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/statistic/report-dynamics-users',
      params: {
        organization_id: organizationId,
        date_from: dateFrom,
        date_to: dateTo,
        max_amount: maxAmount,
        min_amount: minAmount,
        count: countOnPage,
        offset: offset,
        user_name: userName,
      },
    })
  }

  public getDoctorStatistic(filter: StatisticFilterType) {
    const { dateFrom, dateTo } = filter

    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/statistic/doctor',
      params: {
        date_from: dateFrom,
        date_to: dateTo,
      },
    })
  }

  public getPatientsStatistic(filter: StatisticFilterType) {
    const { dateFrom, dateTo } = filter

    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/statistic/patient-plans',
      params: {
        date_from: dateFrom,
        date_to: dateTo,
      },
    })
  }

  public getTariffStatistic() {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/statistic/tariff-usage-statistics',
    })
  }

  public getPlaqueDynamics(
    count: number,
    offset: number,
    tariffTitle: string | null,
    sortingType: string | null,
    organizationName: string | null,
    monthCount: number,
    status: OrganizationStatus,
    showArchive: boolean,
    subscriptionType: OrganizationSubscription,
    sortedColumnDate: string,
    sortedColumnField: string,
    sortedColumnOrder: string
  ) {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/statistic/plaque-dynamics',
      params: {
        offset: offset,
        count: count,
        tariff_name: tariffTitle,
        organization_name: organizationName,
        sorting_type: sortingType,
        month_count: monthCount,
        organization_status: status,
        show_inactive: Number(showArchive),
        subscription_type: subscriptionType,
        sorted_column_date: sortedColumnDate,
        sorted_column_field: sortedColumnField,
        sorted_column_order: sortedColumnOrder,
      },
    })
  }
}

export const statisticApi = new StatisticApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
